import Joi from "joi";

const CountrMasterSchema = Joi.object({
  countryName: Joi.string().trim().required().messages({
    "string.empty": "Country Name is required.",
  }),
  prefix: Joi.string()
    .pattern(/^\+\d{1,4}$/) // Accepts '+' followed by 1 to 4 digits
    .allow("")
    .trim()
    .messages({
      "string.pattern.base":
        "Prefix must start with '+' followed by 1 to 4 digits.",
    }),
  standardCode: Joi.string()
    .pattern(/^[A-Z]+$/) // Ensures only uppercase letters
    .allow("")
    .trim()
    .messages({
      "string.pattern.base": "Standard Code must have UpperCase characters.",
    }),
}).unknown(true);

export default CountrMasterSchema;
